import { Grid2 as Grid } from "@mui/material";
import { useTranslate } from "@refinedev/core";

import { Form, BooksAutocomplete } from "@shared/components";

export function AudioFileForm() {
  const translate = useTranslate();

  return (
    <Grid container spacing={2}>
      <Grid size={{ xs: 12 }}>
        <Form.Input
          name="position"
          label={translate("v1/audiobook_admin.fields.position")}
          required
        />
      </Grid>

      <Grid size={{ xs: 12 }}>
        <BooksAutocomplete
          name="book"
          label={translate("v1/audiobook_admin.fields.book")}
          labelField="title"
          queryHookFilters={{ type: "audiobook" }}
          required
        />
      </Grid>

      <Grid size={{ xs: 12 }}>
        <Form.AudioFilePicker
          name="file"
          label={translate("v1/audiobook_admin.fields.file")}
        />
      </Grid>
    </Grid>
  )
}
